import React, { FC, useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, Grid } from '@material-ui/core';
import { QRCode } from 'react-qrcode-logo';
import { CustomDialogTitle, ExportIcon } from '../../../../components';
import { useStyles } from './styles';
import { useCommonStyles } from '../../../../styles';
import { useAppData } from '../../../../providers';

interface Props {
  open: boolean;
  linkUrl: string;
  translation: any;
  onClose: () => void;
}

export const QrCodeDialog: FC<Props> = ({ open, translation, onClose, linkUrl }) => {
  const classes = useStyles();
  const commonClasses = useCommonStyles();
  const { qrLogoUrl } = useAppData();
  const [logo, setLogo] = useState<string>('');

  useEffect(() => {
    setLogo(qrLogoUrl);
  }, [qrLogoUrl]);

  const downloadQrCode = () => {
    const canvas: any = document.getElementById('QRCode');
    if (canvas) {
      const pngUrl = canvas.toDataURL('image/png');
      const downloadLink = document.createElement('a');
      downloadLink.href = pngUrl;
      downloadLink.download = `QRCode.png`;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    }
  };

  return (
    <Dialog onClose={onClose} open={open} classes={{ paper: classes.dialog }}>
      <CustomDialogTitle title={translation.qr_code} onClose={() => onClose()} />
      <Grid container direction="row" justify="center" alignItems="center" className={classes.qrCodeContainer}>
        <QRCode id="QRCode" logoImage={logo} value={linkUrl} logoPadding={20} logoWidth={110} logoHeight={25} ecLevel="H" size={300} enableCORS />
      </Grid>
      <DialogActions className={commonClasses.dialogAction}>
        <Button fullWidth startIcon={<ExportIcon />} onClick={downloadQrCode} className={commonClasses.activeDialogBtn}>
          {translation.text_1545}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
